import React, { useEffect, useRef, useState } from "react";
import classnames from "classnames";

import ContentEditable from "react-contenteditable";
import Tooltip from "../../uiElements/tooltip/Tooltip";

const CustomTextArea = ({
  value,
  className,
  error,
  label,
  onChange,
  editMode,
  disabled,
}) => {
  const [height, setHeight] = useState(null);
  const myRef = useRef(null);
  useEffect(() => {
    setHeight(myRef.current.clientHeight);
  }, [value, editMode]);

  return (
    <div ref={myRef} className="customText form-group floating mt-n4">
      <ContentEditable
        className={classnames(
          "content-editable form-control floating",
          className
        )}
        html={value}
        style={{ overflowX: "auto", height: "auto" }}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
      />
      {label && (
        <label
          className="text-left input-label"
          style={{
            top: -(height - 43),
          }}
        >
          {label}
        </label>
      )}
      {error && (
        <Tooltip id={error} className="errorBtn">
          {error}
        </Tooltip>
      )}
    </div>
  );
};

export default CustomTextArea;
